// FILE: src/components/SystemRequirements.jsx
import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import requirements from "../constant";

const ICONS = { Device: ComputerOutlinedIcon, Browser: LanguageOutlinedIcon, Internet: WifiOutlinedIcon, Email: MailOutlineIcon };

export default function SystemRequirements() {
  return (
    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
      {requirements.map(({ title, items }) => {
        const Icon = ICONS[title] || CheckIcon;
        return (
          <Card key={title} component="section" aria-labelledby={`req-${title}`}>
            <CardContent>
              <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", mb: 2 }}>
                <Box aria-hidden sx={{ width: 40, height: 40, borderRadius: 2.5, display: "grid", placeItems: "center", bgcolor: "zun.primaryTint", color: "primary.main" }}>
                  <Icon />
                </Box>
                <Typography id={`req-${title}`} variant="h3" component="h2">
                  {title}
                </Typography>
              </Stack>
              <Stack component="ul" spacing={1.25} sx={{ listStyle: "none", m: 0, p: 0 }}>
                {items.map((text) => (
                  <Stack key={text} component="li" direction="row" spacing={1.25} sx={{ alignItems: "flex-start" }}>
                    <CheckIcon aria-hidden sx={{ color: "primary.main", mt: "3px", fontSize: "1.25rem" }} />
                    <Typography>{text}</Typography>
                  </Stack>
                ))}
              </Stack>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
}
